// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1sIFo","checkboxCol":"Table_checkboxCol__7ow34","emailCol":"Table_emailCol__29Aqm","actionCol":"Table_actionCol__3xv58"};